import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { DropdownButton, MenuItem, OverlayTrigger, Popover } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import moment from 'moment';

const STATUS_STYLES = {
  draft: 'default',
  sent: 'info',
  accepted: 'success',
  expired: 'danger',
  converted: 'primary',
  cancelled: 'warning'
};

class DraftList extends Component {

  constructor(props) {
    super(props);
    this.actionsFormatter = this.actionsFormatter.bind(this);
    this.draftNumberFormatter = this.draftNumberFormatter.bind(this);
    this.shopifyIdFormatter = this.shopifyIdFormatter.bind(this);
    this.deliveryStatusFormatter = this.deliveryStatusFormatter.bind(this);
    this.typeFormatter = this.typeFormatter.bind(this);
    this.customerFormatter = this.customerFormatter.bind(this);
    this.statusFormatter = this.statusFormatter.bind(this);
  }

  t(id) {
    return this.props.intl.formatMessage({ id });
  }

  typeFormatter(cell, row) {
    const TYPE_LABELS = {
      quote: this.t('draftList.quote'),
      proforma: this.t('draftList.proforma'),
      draft_order: this.t('draftList.draftOrder'),
      manual_invoice: this.t('draftList.manualInvoice')
    };
    return <span>{TYPE_LABELS[cell] || cell}</span>;
  }

  customerFormatter(cell, row) {
    if (!row.customer) return <label className="label label-warning">{this.t('draftList.noCustomer')}</label>;
    let name = ((row.customer.first_name || '') + ' ' + (row.customer.last_name || '')).trim();
    if (!name && row.customer.company) return <span>{row.customer.company}</span>;
    if (!name) return <label className="label label-warning">{this.t('draftList.noCustomer')}</label>;
    return <span>{name}</span>;
  }

  statusFormatter(cell, row) {
    let style = STATUS_STYLES[cell] || 'default';
    let label = cell ? cell.charAt(0).toUpperCase() + cell.slice(1) : this.t('draftSearch.draft');
    return <label className={`label label-${style}`}>{label}</label>;
  }

  deliveryStatusFormatter(cell, row) {
    let { onDeliver } = this.props;

    if (cell === null || cell === undefined) {
      if (row.status === 'draft') return <span></span>;
      return <span>
        <label className="label label-default">{this.t('draftList.pending')}</label>{' '}
        <label className="label label-primary" style={{cursor:'pointer'}} title={this.t('draftList.deliverNow')} onClick={(e) => {
          e.stopPropagation();
          onDeliver(row.id);
        }}><i className="fa fa-paper-plane"></i></label>
      </span>;
    }

    if (cell === true) {
      let channels = row.delivery_details && row.delivery_details.channels ? row.delivery_details.channels : [];
      let hasFailedChannel = channels.some(ch => ch.status === 'failed');
      let partialReason = row.delivery_details && row.delivery_details.reason ? row.delivery_details.reason : null;

      let popover = <Popover id={`draft-delivery-${row.id}`} title={this.t('draftList.deliveryDetails')} style={{minWidth:'320px', maxWidth:'400px'}}>
        <div style={{padding:'12px'}}>
          {channels.map((ch, i) => {
            let channelLabel = ch.type === 'googleDrive' ? 'Google Drive' : ch.type.charAt(0).toUpperCase() + ch.type.slice(1);
            let channelIcon = ch.type === 'email' ? 'fa-envelope-o' : ch.type === 'googleDrive' ? 'fa-google' : ch.type === 'ftp' ? 'fa-server' : 'fa-paper-plane';
            let failed = ch.status === 'failed';
            return <div key={i} style={{marginBottom: i < channels.length - 1 ? '10px' : 0}}>
              <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                <span style={{fontSize:'12px', fontWeight:600, color:'#1e293b'}}>
                  <i className={`fa ${channelIcon}`} style={{marginRight:6, color:'#64748b'}}></i>
                  {channelLabel}
                </span>
                {failed
                  ? <span style={{fontSize:'11px', color:'#dc3545', fontWeight:500}}><i className="fa fa-times-circle"></i> {this.t('draftList.failed')}</span>
                  : <span style={{fontSize:'11px', color:'#22c55e', fontWeight:500}}><i className="fa fa-check-circle"></i> {this.t('draftList.sent')}</span>}
              </div>
              {ch.type === 'email' && ch.to && <div style={{fontSize:'11px', color:'#64748b', paddingLeft:'22px'}}>To: {ch.to}</div>}
              {ch.type === 'ftp' && <div style={{fontSize:'11px', color:'#64748b', paddingLeft:'22px'}}>{ch.host}:{ch.port} ({ch.secure ? 'SFTP' : 'FTP'})</div>}
              {ch.type === 'googleDrive' && <div style={{fontSize:'11px', color:'#64748b', paddingLeft:'22px'}}>Folder: {ch.folder || 'Invoice Browse'}</div>}
            </div>;
          })}
          {partialReason && <div style={{fontSize:'11px', color:'#dc3545', borderTop:'1px solid #eee', paddingTop:'8px', marginTop:'10px'}}>
            <i className="fa fa-warning"></i> {partialReason}
          </div>}
          <div style={{borderTop:'1px solid #eee', paddingTop:'10px', marginTop:'10px', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
            {row.delivered_at && <span style={{fontSize:'11px', color:'#94a3b8'}}>
              {moment(row.delivered_at).format('MM/DD/YYYY h:mm A')}
            </span>}
            <button className="btn btn-xs btn-default" onClick={(e) => {
              e.stopPropagation();
              onDeliver(row.id);
            }}><i className="fa fa-repeat"></i> {this.t('draftList.deliverAgain')}</button>
          </div>
        </div>
      </Popover>;

      return <OverlayTrigger trigger="click" rootClose placement="left" overlay={popover}>
        <label className={`label ${hasFailedChannel ? 'label-warning' : 'label-success'}`} style={{cursor:'pointer'}}>{hasFailedChannel ? this.t('draftList.partial') : this.t('draftList.delivered')}</label>
      </OverlayTrigger>;
    }

    let reason = row.delivery_details && row.delivery_details.reason ? row.delivery_details.reason : this.t('draftList.unknown');
    let popover = <Popover id={`draft-delivery-${row.id}`} title={this.t('draftList.deliveryFailed')}>
      <p style={{fontSize:'12px', margin:0}}>{reason}</p>
      <div style={{borderTop:'1px solid #eee', paddingTop:'6px', marginTop:'8px'}}>
        <button className="btn btn-xs btn-primary" onClick={(e) => {
          e.stopPropagation();
          onDeliver(row.id);
        }}><i className="fa fa-paper-plane"></i> {this.t('draftList.deliverNow')}</button>
      </div>
    </Popover>;
    return <OverlayTrigger trigger="click" rootClose placement="left" overlay={popover}>
      <label className="label label-danger" style={{cursor:'pointer'}}>{this.t('draftList.notDelivered')}</label>
    </OverlayTrigger>;
  }

  getThemesForDraft(row) {
    let { user } = this.props;
    let themes = (user && user.themes) || [];
    let docType = row.document_type;
    if (docType === 'quote') {
      return themes.filter(t => !t.documentType || t.documentType === '' || t.documentType === 'quote');
    }
    if (docType === 'proforma') {
      return themes.filter(t => !t.documentType || t.documentType === '' || t.documentType === 'proforma');
    }
    return themes.filter(t => t.documentType !== 'refund' && t.documentType !== 'credit-note' && t.documentType !== 'storno');
  }

  shopifyIdFormatter(cell, row) {
    if (!row.shopify_draft_order_id) return <span></span>;
    let shopName = this.props.user && this.props.user.shopify ? this.props.user.shopify.shopName : '';
    let label = row.shopify_draft_order_name || `#D${row.shopify_draft_order_id}`;
    if (!shopName) return <span style={{ fontSize: '12px' }}>{label}</span>;
    return (
      <a
        href={`https://admin.shopify.com/store/${shopName}/draft_orders/${row.shopify_draft_order_id}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        style={{ fontSize: '12px' }}
      >
        {label}
      </a>
    );
  }

  draftNumberFormatter(cell, row) {
    let prefix = row.prefix || '';
    let themes = this.getThemesForDraft(row);

    return (
      <div>
        <button
          className="btn btn-sm btn-grid-sm btn-default"
          onClick={(e) => { e.stopPropagation(); this.props.onEdit(row); }}
        >
          #{prefix}{row.draft_number}
        </button>{' '}

        {themes.length === 0 ?
          <button title={this.t('draftList.download')} onClick={(e) => {
            e.stopPropagation();
            window.open(`/drafts/download?id=${row.id || row._id}`, '_blank');
          }} className="btn btn-success btn-sm btn-grid-sm" type="button">
            <i className="fa fa-download"></i>&nbsp;{this.t('draftList.download')}
          </button> :
          <DropdownButton
            id={`draft-download-${row.id}`}
            onClick={(e) => e.stopPropagation()}
            className="btn btn-success btn-sm btn-grid-sm"
            title={this.t('draftList.download')}
            onSelect={(theme) => {
              window.open(`/drafts/download?id=${row.id || row._id}&template=${encodeURIComponent(theme)}`, '_blank');
            }}
          >
            {themes.sort((a, b) => b.isPrimary - a.isPrimary).map((t) =>
              <MenuItem key={t.name} eventKey={t.name}>{t.isPrimary ? `${t.name} - ${this.t('draftList.default')}` : t.name}</MenuItem>
            )}
          </DropdownButton>}
      </div>
    );
  }

  actionsFormatter(cell, row) {
    let { onEdit, onDelete, onSend, onConvert, onComplete, onDuplicate } = this.props;
    let status = row.status || 'draft';

    return (
      <DropdownButton
        id={`draft-actions-${row.id}`}
        title={this.t('draftList.actions')}
        bsSize="xs"
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem eventKey="edit" onSelect={() => onEdit(row)}>
          <i className="fa fa-pencil"></i>&nbsp;{this.t('draftList.edit')}
        </MenuItem>
        {(status === 'draft' || status === 'sent') && <MenuItem eventKey="send" onSelect={() => onSend(row.id)}>
          <i className="fa fa-paper-plane"></i>&nbsp;{this.t('draftList.send')}
        </MenuItem>}
        {(status === 'draft' || status === 'sent' || status === 'accepted') && <MenuItem eventKey="convert" onSelect={() => onConvert(row.id)}>
          <i className="fa fa-exchange"></i>&nbsp;{this.t('draftList.pushToShopify')}
        </MenuItem>}
        {(status === 'draft' || status === 'sent' || status === 'accepted') && <MenuItem eventKey="complete" onSelect={() => onComplete(row.id)}>
          <i className="fa fa-check"></i>&nbsp;{this.t('draftList.complete')}
        </MenuItem>}
        <MenuItem eventKey="duplicate" onSelect={() => onDuplicate(row.id)}>
          <i className="fa fa-copy"></i>&nbsp;{this.t('draftList.duplicate')}
        </MenuItem>
        {status !== 'converted' && <MenuItem divider />}
        {status !== 'converted' && <MenuItem eventKey="delete" onSelect={() => onDelete(row.id)}>
          <i className="fa fa-trash"></i>&nbsp;{this.t('draftList.delete')}
        </MenuItem>}
      </DropdownButton>
    );
  }

  render() {
    let { list, totalCount, onPageChange, page, sizePerPage, fetching, onRowSelect, onSelectAll } = this.props;

    let options = {
      noDataText: (
        <div style={{ textAlign: 'center', color: 'grey' }}>
          {fetching && <h1><i className="fa fa-spin fa-circle-o-notch"></i></h1>}
          {list.length === 0 && !fetching && <h4>{this.t('draftList.noDrafts')}</h4>}
        </div>
      ),
      onPageChange: (nextPage) => {
        onPageChange(nextPage, sizePerPage);
      },
      sizePerPage: sizePerPage,
      sizePerPageList: [20],
      page: page
    };

    let selectRow = {
      mode: 'checkbox',
      clickToSelect: true,
      onSelect: onRowSelect,
      onSelectAll: onSelectAll
    };

    return (
      <div id="all-drafts" style={{ overflow: 'visible' }}>
        <BootstrapTable
          ref={(instance) => { this.table = instance; }}
          headerContainerClass={fetching ? "campaign-list-header disabled" : "campaign-list-header"}
          options={options}
          selectRow={selectRow}
          data={list || []}
          hover
          fetchInfo={{ dataTotalSize: totalCount }}
          remote={true}
          pagination={true}
        >
          <TableHeaderColumn width="140" isKey dataField="_id" columnClassName="table-menu" dataFormat={this.draftNumberFormatter}>{this.t('draftList.draftNum')}</TableHeaderColumn>
          <TableHeaderColumn width="80" dataField="shopify_draft_order_id" dataFormat={this.shopifyIdFormatter}>{this.t('draftList.shopifyId')}</TableHeaderColumn>
          <TableHeaderColumn width="120" dataField="document_type" dataFormat={this.typeFormatter}>{this.t('draftList.type')}</TableHeaderColumn>
          <TableHeaderColumn width="150" dataField="customer" dataFormat={this.customerFormatter}>{this.t('draftList.customer')}</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="total_price" dataFormat={(cell, row) => <span>{parseFloat(cell || 0).toFixed(2)} {row.currency}</span>}>{this.t('draftList.total')}</TableHeaderColumn>
          <TableHeaderColumn width="80" dataField="status" dataFormat={this.statusFormatter}>{this.t('draftList.status')}</TableHeaderColumn>
          <TableHeaderColumn width="80" dataField="delivered" dataFormat={this.deliveryStatusFormatter}>{this.t('draftList.delivered')}</TableHeaderColumn>
          <TableHeaderColumn width="140" dataField="date_created" dataFormat={(cell) => cell ? <span>{moment(cell).format('MM/DD/YYYY h:mm A')}</span> : <span>-</span>}>{this.t('draftList.date')}</TableHeaderColumn>
          <TableHeaderColumn width="100" dataField="actions" columnClassName="table-menu" dataFormat={this.actionsFormatter}>{this.t('draftList.actions')}</TableHeaderColumn>
        </BootstrapTable>
        {fetching && <p style={{ textAlign: "center", fontSize: 14 }}><span>&nbsp;{this.t('draftList.loading')}</span></p>}
      </div>
    );
  }
}

DraftList.propTypes = {
  list: PropTypes.array,
  user: PropTypes.object,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  onDeliver: PropTypes.func.isRequired,
  onConvert: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowSelect: PropTypes.func,
  onSelectAll: PropTypes.func,
  page: PropTypes.number,
  sizePerPage: PropTypes.number,
  totalCount: PropTypes.number,
  fetching: PropTypes.bool
};

export default injectIntl(DraftList);



// WEBPACK FOOTER //
// app/components/drafts/DraftList.jsx